<template>
  <div class="maandSlider">
    <MaandWieber v-for="maand in months" :key="maand.id" :maand="maand"/>
  </div>
</template>
<style>

</style>

<script>
/**
  Componentje voor de maand slider, elke maand is een maandWieber component. Beschikbare
  maanden zijn oranje, niet beschikbare maanden zijn grijs en de actieve maand is blauw en groot.

  Een beschikbare maand is klikbaar zodat je van maand kan wisselen.
 */

import MaandWieber from '../components/MaandWieber.vue'

export default {

  name: 'MaandSlider',
  components: {
    MaandWieber
  },
  computed: {
    months() {
      return this.$store.state.config.months
    }
  }
}
</script>